/**
 * INR formatting (Sprint 7, Part 87) — single source replacing scattered
 * lakh/crore helpers across pages.
 */

/** 1234567.5 -> "₹12,34,567.5" (en-IN grouping) */
export function formatINR(amount) {
  const value = Number(amount ?? 0);
  if (!Number.isFinite(value)) return "₹0";
  return `₹${value.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
}

/** 15000000 -> "₹1.5Cr", 320000 -> "₹3.2L" */
export function inrCompact(amount) {
  const value = Number(amount ?? 0);
  if (!Number.isFinite(value)) return "₹0";
  const abs = Math.abs(value);
  if (abs >= 10000000) return `₹${(value / 10000000).toFixed(1)}Cr`;
  if (abs >= 100000) return `₹${(value / 100000).toFixed(1)}L`;
  return formatINR(value);
}
